import {useMedia} from 'react-use';

export const useMobile = () => {
  const isMobile = useMedia('(max-width: 1000px)');
  return [isMobile];
};